import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-invite-partner",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row">
			<div class="col-12">
				<p>{{ "please_enter_partner_email" | langVal }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<app-gen-input
					[actualObj]="this"
					[errors]="errors"
					fieldName="email"
					(keyupEvent)="validateEntireForm()"
					(changeEvent)="validateEntireForm()"
				></app-gen-input>
			</div>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				text="continue_to_email"
				[disabled]="!isFormSubmittable"
				tabindex="1"
				(clickEv)="submit()"
				[isSpin]="isSaving"
			/>
		</div>
	`,
})
export class InvitePartnerComponent extends Modalable {
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	email: string = ""
	validationFields: any = {
		email: { not_empty: null, email: null },
	}
	isSaving: boolean = false

	validateEntireForm() {
		this.isFormSubmittable = this.validator.validateEntireForm(
			this,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		this.isSaving = true
		const res = await this.apiService.post("invite_partner", this, "email")
		this.isSaving = false
		if (res?.is_partner) {
			this.isFormSubmittable = false
			this.errors.email = this.lang.getVal("already_in_partnership")
			return
		}
		this.modalService.openToast("invitation_sent_successfully")

		this.onClose.emit
	}
}
